import React from 'react';

import LabelValue from '@/comp/MapBuilder/nodes/nodeWidget/DetailsDrawer/Tabs/AssetInfo/LabelValue/LabelValue';
import type { Device } from '@/store/Station/constants';
import type { StaticInfo } from '@/comp/StationControlCenter/types/universal-device.types';
import { Container } from './StaticInfoSection.styles';
import { getStaticInfoItems } from '../UniversalAssetInfo.utils';
import { useTranslation } from 'react-i18next';
import { useMeasurement } from '@/hooks/useMeasurement';
import { observer } from 'mobx-react';

type DeviceMeta = {
  attributes?: Record<string, unknown>;
};

interface StaticInfoSectionProps {
  deviceFromStationStore: Device;
  deviceFromDevicesStore?: DeviceMeta;
  staticInfo: StaticInfo[];
}

const StaticInfoSection = observer(
  ({ deviceFromStationStore, deviceFromDevicesStore, staticInfo }: StaticInfoSectionProps) => {
    const { t } = useTranslation();
    const { tvalue, tunit } = useMeasurement();
    const items = getStaticInfoItems(deviceFromStationStore, deviceFromDevicesStore, staticInfo);
    return (
      <Container>
        {items.map((item) => {
          const unit = item.unit;
          if (item.value === 'N/A') return null;
          return (
            <LabelValue
              key={item.key}
              label={t(item.label)}
              value={tvalue(item.value, unit)}
              unit={t(tunit(unit))}
            />
          );
        })}
      </Container>
    );
  },
);

export default StaticInfoSection;

